module.exports = __webpack_public_path__ + "static/img/xueqr.0c650b4.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/img/xueqr.png
// module id = sTL2
// module chunks = 1